import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import {
  DialogContentText,
  FormControl,
  FormLabel,
  Typography,
} from "@mui/material";
import CVData from "../../../../types/CVData";

export default function CustomAddCvDialog({
  open,
  onClose,
  cv,
  onSave,
}: {
  open: boolean;
  onClose: () => void;
  cv: any;
  onSave: (updatedCv: CVData) => void;
}) {
  const [formData, setFormData] = useState<any>({
    cvId: "",
    name: "",
    cvUId: "",
    position: {
    },
    professionalSummary: "",
    skills: {
      backend: [],
      cloud: [],
      devOps: [],
      frontend: [],
      others: [],
      tools: [],
      database: [],
    },
    professionalAffiliations: [],
    certifications: [],
    education: [],
    languages: {
      english: "",
      nativeLanguage: "",
      otherLanguages: [],
    },
    status: "active",
    type: "employee",
  });
  const [errors, setErrors] = useState({
    cvId: "",
    name: "",
  });

  const isEditMode = !!cv;
 
  useEffect(() => {
    if (cv) {
      setFormData({
        cvId: cv.cvId || "",
        name: cv.name || "",
      });
    } else {
      setFormData({
        cvId: "",
        name: "",
      });
    }
  }, [cv]);

  const handleTextChange =
    (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
      setFormData({ ...formData, [field]: e.target.value });

      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: "", // Clear error when user types
      }));
    };

  const handleSave = () => {
    if (!validate()) return;
    onSave(formData);
    onClose(); // Close the dialog
  };

  const validate = () => {
    const newErrors: any = {};
    let isValid = true;

    if (!formData.name) {
      newErrors.name = "Name is required.";
      isValid = false;
    }

    if (!formData.cvId) {
      newErrors.cvId = "Email is required.";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.cvId)) {
      newErrors.cvId = "Invalid email format.";
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          component: "form",
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            onClose();
          },
          sx: { backgroundImage: "none" },
        },
      }}
    >
      <DialogTitle>
        <Typography
          variant="overline"
          sx={{
            color: "text.secondary",
            letterSpacing: 0.8,
            fontWeight: 700,
          }}
        >
          {isEditMode ? "Edit Cv" : "Add Cv"}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <FormLabel htmlFor="name">Name</FormLabel>
          <TextField
            value={formData.name || ""}
            error={Boolean(errors.name)}
            placeholder="Name"
            onChange={handleTextChange("name")}
          />
          {errors.name && (
            <p style={{ color: "red", fontSize: "10px" }}>{errors.name}</p>
          )}
        </FormControl>
        
        <FormControl fullWidth sx={{ mt: 1 }}>
          <FormLabel htmlFor="cvId">Email</FormLabel>
          <TextField
            value={formData.cvId || ""}
            error={Boolean(errors.cvId)}
            placeholder="Email"
            disabled={isEditMode}
            onChange={handleTextChange("cvId")}
          />
          {errors.cvId && (
            <p style={{ color: "red", fontSize: "10px" }}>{errors.cvId}</p>
          )}
        </FormControl>
        <DialogContentText sx={{ mt: 2 }}>
          *this does not invite the user, it only creates a blank CV with the given email address.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          {isEditMode ? "Save Changes" : "Add CV"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
